import { ICoordinateComments } from '../../core/interfaces/coordinate-comments.interface';
import { getCommentIconSVG } from '../../Utils/icons';
import mapboxgl from 'mapbox-gl';

export const parseCoordinate = (coordinate: string | object): mapboxgl.LngLat | null => {
  if (coordinate) {
    const { lng, lat } = coordinate as { lng: number; lat: number };
    return new mapboxgl.LngLat(lng, lat);
  }
  return null;
};

export const createMarkerElement = (
  comment: ICoordinateComments,
  onClick: (e: MouseEvent) => void,
): HTMLElement => {
  const markerEl = document.createElement('div');
  markerEl.className = 'comment-marker';

  const iconEl = document.createElement('div');
  iconEl.innerHTML = getCommentIconSVG();
  iconEl.style.display = 'flex';
  iconEl.style.alignItems = 'center';
  iconEl.style.justifyContent = 'center';

  markerEl.appendChild(iconEl);
  markerEl.addEventListener('click', (e) => {
    e.stopPropagation();
    onClick(e);
  });

  return markerEl;
};

export const createPopupContentFromComment = (
  comment: ICoordinateComments,
  callbacksOrFn?: any,
): HTMLElement => {
  console.log('createPopupContentFromComment called', { comment, callbacksOrFn });
  const popupContainer = document.createElement('div');
  popupContainer.style.display = 'flex';
  popupContainer.style.flexDirection = 'column';
  popupContainer.style.alignItems = 'center';
  popupContainer.style.textAlign = 'center';
  popupContainer.style.width = '220px';

  // Support legacy signature where second arg is onDelete function
  let onDelete: (() => void) | undefined;
  let onSave: ((text: string) => void) | undefined;
  let onCancel: (() => void) | undefined;

  if (typeof callbacksOrFn === 'function') {
    onDelete = callbacksOrFn as () => void;
  } else if (callbacksOrFn && typeof callbacksOrFn === 'object') {
    onDelete = callbacksOrFn.onDelete;
    onSave = callbacksOrFn.onSave;
    onCancel = callbacksOrFn.onCancel;
  }

  // Determine if we should render the new-comment input.
  const hasText = comment && typeof comment.comment === 'string' && comment.comment.trim().length > 0;
  const hasSaveOrCancel = !!(onSave || onCancel);
  const isNewComment = !hasText && hasSaveOrCancel;
  if (isNewComment) {
    const textarea = document.createElement('textarea');
    textarea.placeholder = 'Enter comment...';
    textarea.style.width = '90%';
    textarea.style.minHeight = '70px';
    textarea.style.marginBottom = '8px';
    // Make textarea visually prominent in case global CSS hides it
    textarea.style.background = 'white';
    textarea.style.color = 'black';
    textarea.style.border = '1px solid rgba(0,0,0,0.2)';
    textarea.style.padding = '6px';
    textarea.addEventListener('click', (e) => e.stopPropagation());
    // ensure the textarea is focused when the popup opens
    setTimeout(() => {
      try {
        textarea.focus();
      } catch (e) {
        // ignore
      }
    }, 0);

    const buttonsRow = document.createElement('div');
    buttonsRow.style.display = 'flex';
    buttonsRow.style.justifyContent = 'center';
    buttonsRow.style.gap = '8px';
    buttonsRow.style.width = '100%';

    const saveBtn = document.createElement('button');
    saveBtn.innerText = 'Save';
    saveBtn.className = 'comment-save-button';
    // style as primary button with white text
    saveBtn.style.background = 'var(--gentian-primary)';
    saveBtn.style.color = 'white';
    saveBtn.style.border = 'none';
    saveBtn.style.padding = '6px 12px';
    saveBtn.style.borderRadius = '4px';
    saveBtn.style.cursor = 'pointer';
    // hover effect: slightly darken
    saveBtn.addEventListener('mouseenter', () => {
      saveBtn.style.filter = 'brightness(0.9)';
    });
    saveBtn.addEventListener('mouseleave', () => {
      saveBtn.style.filter = '';
    });
    saveBtn.onclick = (e) => {
      e.stopPropagation();
      onSave?.(textarea.value.trim());
    };

    buttonsRow.appendChild(saveBtn);

    popupContainer.appendChild(textarea);
    popupContainer.appendChild(buttonsRow);
    return popupContainer;
  }

  // Existing comment view
  const messageContainer = document.createElement('div');
  messageContainer.style.width = '100%';
  messageContainer.style.maxHeight = '4.5em';
  messageContainer.style.overflow = 'hidden';
  messageContainer.style.display = '-webkit-box';
  (messageContainer.style as any).webkitBoxOrient = 'vertical';
  (messageContainer.style as any).webkitLineClamp = '3';
  messageContainer.style.textOverflow = 'ellipsis';
  messageContainer.style.lineHeight = '1.5em';
  messageContainer.style.textAlign = 'left';
  messageContainer.innerHTML = comment.comment;

  messageContainer.onclick = () => {
    const isExpanded = messageContainer.style.maxHeight === 'none';
    messageContainer.style.maxHeight = isExpanded ? '4.5em' : 'none';
    messageContainer.style.display = isExpanded ? '-webkit-box' : 'block';
  };

  const deleteButton = document.createElement('button');
  deleteButton.innerText = 'Delete';
  deleteButton.className = 'delete-comment-button';

  deleteButton.onclick = (e) => {
    e.stopPropagation();
    onDelete?.();
  };

  popupContainer.appendChild(messageContainer);
  popupContainer.appendChild(deleteButton);

  return popupContainer;
};
